import styled from '@emotion/styled';
import { switchProp, ifProp } from 'styled-tools';
import { Sticky } from '~/shared/components/Sticky';
import { breakpoints, getClampFullRange } from '~/theme';

export const StyledProductList = styled.div<{ isSearch?: boolean }>(
    ({ theme }) => ({
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        borderBottom: theme.traits.line.stylisticVisible ? theme.traits.line.asBorderStyle : '',
    }),
    ifProp('isSearch', ({ theme }) => ({
        flexDirection: 'column',
        [breakpoints.md]: {
            flexDirection: 'row',
            marginTop: theme.spaces[4],
        },
    }))
);

export const StyledCategoriesContainer = styled(Sticky)<{ isSearch?: boolean }>(
    ({ theme }) => ({
        display: 'none',
        [breakpoints.md]: {
            width: `${theme.sizes.categoriesSidebarWidth}px`,
            paddingRight: theme.spaces[5],
            display: 'flex',
            flexDirection: 'column',
            marginTop: theme.spaces[5],
            marginBottom: theme.spaces[6],
        },
    }),
    ifProp('isSearch', () => ({
        display: 'flex',
        width: '100%',
        [breakpoints.md]: {
            flexDirection: 'row',
            alignItems: 'flex-start',
        },
    }))
);

export const StyledProductListContainer = styled.div({
    flex: '1 1 100%',
});


export const StyledProductsHeader = styled.div<{ topMargin: 'little' | 'default' }>(
    ({ theme }) => ({
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        padding: `${theme.spaces[2]} 0`,
        [breakpoints.md]: {
            padding: 0,
            marginBottom: 0,
        },
    }),
    switchProp('topMargin', {
        little: {
            marginTop: 0,
        },
        default: ({ theme }) => ({
            marginTop: `${getClampFullRange(theme.spacesRaw[2], theme.spacesRaw[4])}`,
            [breakpoints.md]: {
                marginTop: `${getClampFullRange(theme.spacesRaw[4], theme.spacesRaw[7])}`,
            },
        }),
    })
);



